<div class="d-flex justify-content-center">
    <a  [href]="link_now" target="_blank">{{ 'homePage.txtRecover' | translate }}</a>
</div>
